export function useQpdWithItems({
  initialValue,
  maxItems,
  setQualifyingParamValue
}: {
  initialValue: { value: number | null; items: { name: string; value: number }[] }
  maxItems: number
  setQualifyingParamValue: (value: number | null, items: { name: string; value: number }[]) => void
}) {
  const onNameChange = (evt: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const totalValue = initialValue.items.reduce((acc, element) => {
      return acc + (element.value || 0)
    }, 0)

    const items = initialValue.items.map((element, i) => {
      if (i === index) {
        return { ...element, name: evt.target.value }
      }
      return element
    })

    setQualifyingParamValue(totalValue, items)
  }

  const onValueChange = (evt: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const updatedElements = initialValue.items.map((element, i) => {
      if (i === index) {
        return { ...element, value: parseFloat(evt.target.value) }
      }
      return element
    })

    const hasElements = updatedElements.length > 0

    const totalValue = updatedElements.reduce((acc, element) => {
      return acc + (element.value || 0)
    }, 0)

    setQualifyingParamValue(hasElements ? totalValue : null, updatedElements)
  }

  const onRemoveOtherElement = (index: number) => {
    const updatedElements = initialValue.items.filter((_, i) => i !== index) || []

    const totalValue = updatedElements.reduce((acc, element) => {
      return acc + (element.value || 0)
    }, 0)

    const hasElements = updatedElements.length > 0

    setQualifyingParamValue(hasElements ? totalValue : null, updatedElements)
  }

  const onAddOtherElement = () => {
    if (initialValue.items.length < maxItems) {
      const newElement = { name: '', value: 1 }

      const totalValue = initialValue.items.reduce((acc, element) => {
        return acc + (element.value || 0)
      }, 0)

      setQualifyingParamValue(totalValue + newElement.value, [...initialValue.items, newElement])
    }
  }

  return {
    onNameChange,
    onValueChange,
    onRemoveOtherElement,
    onAddOtherElement
  }
}
